export default __webpack_public_path__ + "static/media/shatter.aecbf258.png";